import React, { useState } from 'react';
import { Header } from './components/Header';
import { CatalogPage } from './pages/CatalogPage';
import { VehicleDetail } from './pages/VehicleDetail';
import { MessageCircle } from 'lucide-react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  const [searchQuery, setSearchQuery] = useState('');
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-[#E8E8E8] font-sans text-[#1C1C1C]" data-id="element-2">
        <Header data-id="element-3" />

        <Routes data-id="element-4">
          <Route path="/" element={<CatalogPage searchQuery={searchQuery} setSearchQuery={setSearchQuery} data-id="element-6" />} data-id="element-5" />
          <Route path="/autos/:id" element={<VehicleDetail data-id="element-8" />} data-id="element-7" />
        </Routes>

        <a href="https://wa.me/5491100000000" target="_blank" rel="noopener noreferrer" aria-label="Consultar por WhatsApp" className="wa-blink fixed bottom-6 right-6 w-14 h-14 bg-[#25D366] hover:bg-[#128C7E] text-white rounded-full shadow-lg flex items-center justify-center transition-colors z-40 hover:scale-110" data-id="element-9">
          <MessageCircle className="w-7 h-7" data-id="element-10" />
        </a>
      </div>
    </BrowserRouter>;
}